module.exports = __webpack_public_path__ + "img/derby_600.424913b8.png";